import type { ImageLoaderProps } from 'next/image';

const ABSOLUTE_URL_REGEX = /^https?:\/\//i;
const isAbsoluteUrl = (src: string) => ABSOLUTE_URL_REGEX.test(src);

/**
 * Custom loader for next/image using BunnyCDN Optimizer.
 * @see https://nextjs.org/docs/app/api-reference/next-config-js/images
 * @see https://docs.bunny.net/docs/stream-image-processing
 */
export default function bunnyLoader({
  src,
  width,
  quality,
}: ImageLoaderProps): string {
  const url = new URL(src, 'http://temp');
  const params = url.searchParams;

  // BunnyCDN uses 'width' instead of 'w', and 'quality' instead of 'q'.
  // Setting only width maintains aspect ratio automatically.
  params.set('width', width.toString());
  params.set('quality', quality?.toString() ?? '85');

  // BunnyCDN Optimizer automatically serves WebP/AVIF when enabled on the pull zone,
  // so we don't need explicit format parameters.

  // If the src was not absolute to begin with return the pathname and query
  // params only. Note: url.search already includes the '?' prefix.
  if (!isAbsoluteUrl(src)) {
    return `${url.pathname}${url.search}`;
  }

  let { href } = url;

  if (href.includes('https://staging-')) {
    return href;
  }

  // Remove S3 bucket prefix if present
  href = href.replace('s3.eu-west-2.amazonaws.com/', '');

  // Keep cdn.uppbeat.io URLs as-is (served by BunnyCDN)
  // Keep cdn.musicvine.com URLs as-is (served by BunnyCDN)

  return href;
}
